import React from 'react'
import SelectedAddress from '../../layout/selected-address.component.jsx'
import Button from '../../buttons/buttons.component.jsx'
import { AddressService } from './../../../services/address.service'
import { StyledAddressSection } from '../address-manager/styles/address-section.style'
import ChangeAddressModal from './change-address-modal.component.jsx'
import { NewAddressModal } from './new-address-modal.component'

class ShippingAddress extends React.Component {
	constructor(props) {
		super(props)
		this.closeChangeAddressModal = closeChangeAddressModal.bind(this)
		this.openChangeAddressModal = openChangeAddressModal.bind(this)
		this.closeNewAddressModal = closeNewAddressModal.bind(this)
		this.openNewAddressModal = openNewAddressModal.bind(this)
		this.onAddressSelected = onAddressSelected.bind(this)
		this.onAddressRemoved = onAddressRemoved.bind(this)
		this.updateAddress = updateAddress.bind(this)

		this.state = {
			addresses: [
				{
					street: '',
					number: 0,
					neighborhood: '',
					zipCode: '',
					complement: '',
					city: '',
					state: '',
					shippingAddress: true
				}
			],
			isChangeAddressModalOpen: false,
			isNewAddressModalOpen: false,
			editingAddress: null
		}
	}

	getSelectedAddress() {
		return this.state.addresses.find(({ shippingAddress }) => shippingAddress)
	}

	componentWillMount() {
		refreshAddresses.call(this)
	}

	render() {
		const {
			addresses,
			editingAddress,
			isNewAddressModalOpen,
			isChangeAddressModalOpen
		} = this.state

		const address = addresses.find(({ shippingAddress }) => shippingAddress)
		return (
			<StyledAddressSection>
				{
					address ? <SelectedAddress address={address} /> : 'Sem endereço cadastrado'
				}
				<Button
					secondary
					type="button"
					onClick={this.openChangeAddressModal}>
					Adicionar ou Alterar endereço
				</Button>
				<ChangeAddressModal
					onClose={this.closeChangeAddressModal}
					onEdit={this.openNewAddressModal}
					onChange={this.onAddressSelected}
					isOpen={isChangeAddressModalOpen}
					onRemove={this.onAddressRemoved}
					addresses={addresses}
				/>
				<NewAddressModal
					onClose={this.closeNewAddressModal}
					updateAddress={this.updateAddress}
					editingAddress={editingAddress}
					isOpen={isNewAddressModalOpen}
					addresses={addresses}
				/>
			</StyledAddressSection>
		)
	}
}

function updateAddress(address) {
	const { addresses, editingAddress } = this.state
	const isEdit = editingAddress !== null

	if (isEdit) {
		addresses[editingAddress] = address
		this.setState({ addresses })
	} else refreshAddresses.call(this)
}

function refreshAddresses() {
	const { addresses } = this.state
	const shippingAddress = addresses.find(
		({ shippingAddress }) => shippingAddress
	)

	AddressService.getAddresses().then(({ data }) => {
		this.setState({
			addresses: data.map(
				address => (
					(address.shippingAddress =
						(shippingAddress && address.id == shippingAddress.id) ||
						address.billingAddress),
					address
				)
			)
		})
	})
}

function closeNewAddressModal() {
	this.setState({ isNewAddressModalOpen: false })
}

function openNewAddressModal(index) {
	this.setState({ isNewAddressModalOpen: true, editingAddress: index })
}

function onAddressRemoved(addressId) {
	const addresses = this.state.addresses.filter(({ id }) => id !== addressId)

	this.setState({ addresses })
}

function onAddressSelected(selectedIndex) {
	const addresses = this.state.addresses.map(
		(address, index) => (
			(address.shippingAddress = selectedIndex == index), address
		)
	)

	this.setState({ addresses, isChangeAddressModalOpen: false })
}

function openChangeAddressModal() {
	this.setState({ isChangeAddressModalOpen: true })
}

function closeChangeAddressModal() {
	this.setState({ isChangeAddressModalOpen: false })
}

export default ShippingAddress
